import { TThunkAction } from '../../types/redux';
import { resolveLkType } from '../../services/lkType';
import { ELkType } from '../../repositories/lk-type/entities/get_lk_type_v2/GetLkTypeResponseV2';
import { setLkType } from './types';

export function getLkTypeAction(): TThunkAction<Promise<ELkType | null>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;
    const lkType = await resolveLkType({ httpApi, logger });
    dispatch(setLkType(lkType));

    return lkType;
  };
}
